import {
  ChangeDetectionStrategy,
  Component,
  DestroyRef,
  inject,
  OnInit,
  output,
  signal,
} from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

import { TranslateModule } from '@ngx-translate/core';
import { IconName } from '@rp/shared/components';
import { CentsToDollarsPipe } from '@rp/shared/pipes';

import { BalanceCardComponent } from '../balance-card/balance-card.component';
import { PayoutCardComponent } from '../payout-card/payout-card.component';
import { FINANCE_WEBMASTER_PROVIDER_TOKEN, HttpFinanceWebmasterProvider } from '../../providers';
import { PayoutBalance } from '../../models';

@Component({
  selector: 'rp-balance-cards',
  standalone: true,
  templateUrl: './balance-cards.component.html',
  styleUrl: './balance-cards.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [BalanceCardComponent, PayoutCardComponent, TranslateModule, CentsToDollarsPipe],
  providers: [
    { provide: FINANCE_WEBMASTER_PROVIDER_TOKEN, useClass: HttpFinanceWebmasterProvider },
  ],
})
export class BalanceCardsComponent implements OnInit {
  icons = IconName;

  balance = signal<PayoutBalance>({} as PayoutBalance);

  getPayouts = output();

  private _destroyRef = inject(DestroyRef);
  private _financeWebmasterProvider = inject(FINANCE_WEBMASTER_PROVIDER_TOKEN);

  ngOnInit(): void {
    this._getMyBalance();
  }

  onGetPayouts(): void {
    this.getPayouts.emit();
    this._getMyBalance();
  }

  private _getMyBalance(): void {
    this._financeWebmasterProvider
      .getMyBalance()
      .pipe(takeUntilDestroyed(this._destroyRef))
      .subscribe(balance => this.balance.set(balance));
  }
}
